import React from 'react';
import ZafiroAzul from './Img/piletaschicas/ZafiroAzul.png';
import ZafiroAzulIlustracion from './Img/piletaschicas/ZafiroAzulIlustracion.png';
import Onix from './Img/piletaschicas/Onix.png';
import OnixIlustracion from './Img/piletaschicas/OnixIlustracion.png';
import Aventurina from './Img/piletaschicas/Aventurina.png';
import AventurinaIlustracion from './Img/piletaschicas/AventurinaIlustracion.png';
import Espinela from './Img/piletaschicas/Espinela.png';
import EspinelaIlustracion from './Img/piletaschicas/EspinelaIlustracion.png';
import Alejandrita from './Img/piletaschicas/Alejandrita.png';
import AlejandritaIlustracion from './Img/piletaschicas/AlejandritaIlustracion.png';
import Jade from './Img/piletaschicas/Jade.png';
import JadeIlustracion from './Img/piletaschicas/JadeIlustracion.png';
import Zafiro from './Img/piletaschicas/Zafiro.png';
import ZafiroIlustracion from './Img/piletaschicas/ZafiroIlustracion.png';
import DiamanteRojoIlustracion from './Img/piletaschicas/DiamanteRojoIlustracion.png';




function ModelosGrandes() {
  return (
    <>
      <br /><br /><br />
     <div class="mt-5 w-100">
  <div class="row m-1">
    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Zafiro Azul</h4>
        <img src={ZafiroAzul} class="card-img-top px-3" alt="Zafiro Azul" />
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 8,0 m</div>
            <div class="card border-0 ps-2">Ancho: 3,60 m</div>
            <div class="card ps-2">Profundidad: 1,40 a 1,50 m</div>
            <div class="card border-0 ps-2">Volumen: 30.970 L</div>
          </div>
        </div>
        <div>
          <img src={ZafiroAzulIlustracion} class="card-img-top" alt="Zafiro Azul Ilustración" />
        </div>
      </div>
    </div>

    
    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Onix</h4>
        <img src={Onix} class="card-img-top px-3" alt="Onix" />
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 8,0 m</div>
            <div class="card border-0 ps-2">Ancho: 4,00 m</div>
            <div class="card ps-2">Profundidad: 1,45 a 1,60 m</div>
            <div class="card border-0 ps-2">Volumen: 35.760 L</div>
          </div>
        </div>
        <div>
          <img src={OnixIlustracion} class="card-img-top" alt="Onix Ilustración" />
        </div>
      </div>
    </div>


    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Aventurina</h4>
        <img src={Aventurina} class="card-img-top px-3" alt="Aventurina" />
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 9,0 m</div>
            <div class="card border-0 ps-2">Ancho: 4,00 m</div>
            <div class="card ps-2">Profundidad: 1,40 a 1,60 m</div>
            <div class="card border-0 ps-2">Volumen: 39.580 L</div>
          </div>
        </div>
        <div>
          <img src={AventurinaIlustracion} class="card-img-top" alt="Aventurina Ilustración" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mt-5 w-100">
  <div class="row m-1">

    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Espinela</h4>
        <img src={Espinela} class="card-img-top px-3" alt="Espinela" />
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 9,0 m</div>
            <div class="card border-0 ps-2">Ancho: 3,75 m</div>
            <div class="card ps-2">Profundidad: 1,40 a 1,50 m</div>
            <div class="card border-0 ps-2">Volumen: 36.440 L</div>
          </div>
        </div>
        <div>
          <img src={EspinelaIlustracion} class="card-img-top" alt="Espinela Ilustración" />
        </div>
      </div>
    </div>


    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Alejandrita</h4>
        <img src={Alejandrita} class="card-img-top px-3" alt="Alejandrita" />
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 10,0 m</div>
            <div class="card border-0 ps-2">Ancho: 4,0 m</div>
            <div class="card ps-2">Profundidad: 1,40 a 1,60 m</div>
            <div class="card border-0 ps-2">Volumen: 42.640 L</div>
          </div>
        </div>
        <div>
          <img src={AlejandritaIlustracion} class="card-img-top" alt="Alejandrita Ilustración" />
        </div>
      </div>
    </div>


    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Jade</h4>
        <img src={Jade} class="card-img-top px-3" alt="Jade" />
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 8,0 m</div>
            <div class="card border-0 ps-2">Ancho: 3,30 m</div>
            <div class="card ps-2">Profundidad: 1,40 a 1,45 m</div>
            <div class="card border-0 ps-2">Volumen: 26.560 L</div>
          </div>
        </div>
        <div>
          <img src={JadeIlustracion} class="card-img-top" alt="Jade Ilustración" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mt-5 w-100">
  <div class="row m-1">

    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Zafiro</h4>
        <img src={Zafiro} class="card-img-top px-3" alt="Zafiro" />
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 8,40 m</div>
            <div class="card border-0 ps-2">Ancho: 3,60 m</div>
            <div class="card ps-2">Profundidad: 1,50 a 1,60 m</div>
            <div class="card border-0 ps-2">Volumen: 35.760 L</div>
          </div>
        </div>
        <div>
          <img src={ZafiroIlustracion} class="card-img-top" alt="Zafiro Ilustración" />
        </div>
      </div>
    </div>

    <div class="col-md-4 mb-4">
      <div class="card mt-3" id="border">
        <h4 class="card-title text-center pt-2">Diamante Rojo</h4>
        <div class="card-body">
          <div class="card p-1" id="border">
            <h6 class="ps-1 fw-bold">Medidas</h6>
            <div class="card ps-2">Largo: 10,0 m</div>
            <div class="card border-0 ps-2">Ancho: 4,00 m</div>
            <div class="card ps-2">Profundidad: 1,40 a 1,60 m</div>
            <div class="card border-0 ps-2">Volumen: 41.600 lt</div>
          </div>
        </div>
        <div>
          <img src={DiamanteRojoIlustracion} class="card-img-top" alt="Diamante Rojo Ilustración" />
        </div>
      </div>
    </div>
  </div>
</div>
    </>
  );
}

export default ModelosGrandes;
